<script setup>
import { useI18n } from 'vue-i18n';
import $ from "jquery";

const { t } = useI18n();
</script>
<template>
<div>
<notifications group="success" position="top center"  width="80%"/>
<Loader v-if="loading !== 0" />
<div class="limiter">
	<div class="container-login100" :style="'background-image: url('+bg_url+ '?v=' + v +');'">
		<div class="wrap-login100">
			<form class="login100-form validate-form" >
				<span class="login100-form-logo">
					<!-- <i class="zmdi zmdi-landscape"></i> -->
					<a :href="site_url"><img :src="logo_url + '?v=' + v" style="border-radius: 10px;width: 130px;" /></a>
				</span>
				<span class="login100-form-title p-b-34 p-t-27">{{ t('App Name') }}</span>
				<div :class="'wrap-input100 validate-input ' + cls_invalid_email" :data-validate = "t(showMessage('login_identifier'))"> 
					<input class="input100" type="text" name="email" :placeholder="t('E-Mail Address')" v-model="login_identifier" @keyup="pressKeyLogin">
					<span class="focus-input100" data-placeholder=""></span>
				</div>
				<div :class="'wrap-input100 validate-input ' + cls_invalid_password" :data-validate="t(showMessage('login_password'))">
					<input class="input100" type="password" name="pass" :placeholder="t('Password')" v-model="login_password" @keyup="pressKeyLogin">
					<span class="focus-input100" data-placeholder=""></span>
				</div>
				<div class="contact100-form-checkbox">
					<input class="input-checkbox100" id="ckb1" type="checkbox" name="remember-me" v-model="login_remember">
					<label class="label-checkbox100" for="ckb1">
						{{ t('Remember Me') }}
					</label>
				</div>
				<div class="container-login100-form-btn">
					<button type="button" class="login100-form-btn" @click="submitLogin">
						{{ t('Login') }}
					</button>
				</div>
				<div class="text-center p-t-90">
					<a class="txt1" href="#">
						{{ t('Forgot Your Password?') }}
					</a>
				</div>
			</form>
		</div>
	</div>
</div>
</div>
</template>

<script>
	import axios from 'axios';

    export default {
        computed: {
			v(){
				return window.commonData.settings.v;
			},
			site_url(){
				return window.commonData.settings.site_url;
			},
			logo_url(){
				return window.commonData.settings.site_logo;
			},
			bg_url(){
				return window.commonData.settings.bg_login;
			},
			cls_invalid_email() {
				if(this.showMessage('login_identifier')) return 'alert-validate';
				return '';
			},
			cls_invalid_password() {
				if(this.showMessage('login_password')) return 'alert-validate';
				return '';
			},
			loading(){
				return this.$store.state.services.loading;
			}
        },
		data() {
			return {
				verrors: [],
				login_identifier: '',
				login_password: '',
				login_remember: false,
				interval: null
			}
		},
        mounted() {
            // console.log('App mounted.');
			window.onload = function() {
				if (typeof(window.commonData.theme.config_theme) !== "undefined") {
					var themeconfig = window.commonData.theme.config_theme;
					if(themeconfig){
						console.log('custom theme');
						const style = document.createElement('style');
						style.innerHTML = `
							  .wrap-login100 {
								  background: -webkit-linear-gradient(top, ${themeconfig.login_bg_color1}, ${themeconfig.login_bg_color2});
								  background: -o-linear-gradient(top, ${themeconfig.login_bg_color1}, ${themeconfig.login_bg_color2});
								  background: -moz-linear-gradient(top, ${themeconfig.login_bg_color1}, ${themeconfig.login_bg_color2});
								  background: linear-gradient(top, ${themeconfig.login_bg_color1}, ${themeconfig.login_bg_color2});
								}
								.login100-form-btn {
								  background: -webkit-linear-gradient(bottom, ${themeconfig.login_bg_color1}, ${themeconfig.login_bg_color2});
								  background: -o-linear-gradient(bottom, ${themeconfig.login_bg_color1}, ${themeconfig.login_bg_color2});
								  background: -moz-linear-gradient(bottom, ${themeconfig.login_bg_color1}, ${themeconfig.login_bg_color2});
								  background: linear-gradient(bottom, ${themeconfig.login_bg_color1}, ${themeconfig.login_bg_color2});
								}
								.login100-form-logo{background-color: ${themeconfig.login_bg_color2}}
							`;
						document.head.appendChild(style);
					}else{
						console.log('default theme');
						const style = document.createElement('style');
						style.innerHTML = `
							  .wrap-login100 {
								  background: -webkit-linear-gradient(top, #036615, #02e32b);
								  background: -o-linear-gradient(top, #036615, #02e32b);
								  background: -moz-linear-gradient(top, #036615, #02e32b);
								  background: linear-gradient(top, #036615, #02e32b);
								}
								.login100-form-btn {
								  background: -webkit-linear-gradient(bottom, #036615, #02e32b);
								  background: -o-linear-gradient(bottom, #036615, #02e32b);
								  background: -moz-linear-gradient(bottom, #036615, #02e32b);
								  background: linear-gradient(bottom, #036615, #02e32b);
								}
								.login100-form-logo{background-color: #02e32b}
							`;
						document.head.appendChild(style);
					}
				}
			}
			
			// let $dis = this;
			// if(!this.interval){
				// this.interval = setInterval(function(){ 
					// $dis.loadAppTemp();
				// }, window.resetalltime3, $dis);
			// }
			// this.loadAppTemp();
        },
		methods: {
			loadAppTemp(){
				let form = new FormData();
				// form.append('time', moment());
				axios.post('/apptimetamps', form).then(response => {
                }).catch(error => {
                    // this.$store.commit('setError', 'An error has occured, please contact support.');
                });
			},
			pressKeyLogin: function(e){
				if (e.keyCode === 13) {
					this.submitLogin();	
				} 
			},
			showMessage(field) {
				var error = '';
				if (this.verrors.hasOwnProperty(field)) {
					var msgs =  this.verrors[field];
					if (Array.isArray(msgs)) {
						error = msgs[0];
					}else {
						error =  msgs;
					}
			  };
			  return error;
			},
			async submitLogin() {
				try {
					this.$store.commit("services/serviceLoading");

					// Gửi request đăng nhập
					const response = await axios.post("/api/ajaxLogin", {
						login_identifier: this.login_identifier,
						login_password: this.login_password,
						login_remember: this.login_remember ? true : false
					}, {
						withCredentials: true, // Bắt buộc để gửi cookie
						headers: {
							'Content-Type': 'application/json'
						}
					});

					this.$store.commit("services/serviceFinished");

					// Kiểm tra phản hồi từ server
					if (response.data.error) {
						this.verrors = response.data.message;
						this.$notify({
							group: "success",
							title: response.data.title || "Lỗi đăng nhập",
							text: response.data.message,
							duration: 10000,
							speed: 1000
						});
					} else {
						this.$notify({
							group: "success",
							title: response.data.title || "Thành công",
							text: response.data.message,
							duration: 10000,
							speed: 1000
						});

						// Chuyển hướng nếu có URL từ server
						if (response.data.url) {
							window.location.href = response.data.url;
						} else {
							// Nếu không có URL, load lại trang để xác thực session
							window.location.reload();
						}
					}
				} catch (error) {
					this.$store.commit("services/serviceFinished");

					// Xử lý lỗi từ server hoặc lỗi mạng
					let errorMessage = "Đã xảy ra lỗi không xác định.";
					if (error.response) {
						console.error("Lỗi từ server:", error.response.data);
						errorMessage = error.response.data.message || errorMessage;
					} else if (error.request) {
						console.error("Lỗi request:", error.request);
						errorMessage = "Không thể kết nối đến server, vui lòng kiểm tra mạng.";
					} else {
						console.error("Lỗi khác:", error.message);
					}

					// Hiển thị thông báo lỗi
					this.$notify({
						group: "success",
						title: error.response?.data?.title || "Lỗi đăng nhập",
						text: typeof errorMessage === "string" ? errorMessage : "",
						duration: 10000,
						speed: 1000
					});

					this.verrors = errorMessage;
				}
			}
		}
		
    }
</script>
<style>

</style>